import { TFunction } from "i18next";
import { z } from "zod";

// Sentinel value used in <select> elements to represent "All" (which maps to
// null on the wire). Empty string would also work but is more error-prone.
export const FEATURE_FLAG_ALL_VALUE = "ALL";

// Schema for the FeatureFlag create form.
// `country` uses the sentinel "ALL" to mean "no scope" and is later converted
// to null in the page before dispatching the saga. `environment` is not part
// of the form — the admin dashboard is already deployed per-environment, so
// it's derived automatically from that environment rather than user-selected.
export const featureFlagRuleSchema = (t: TFunction) =>
  z.object({
    flagName: z.enum(
      ["MANAGER_LICENCE", "DOCTOR_LICENCE", "STATIC_DOCTOR_DIRECTORY"],
      {
        error: () => ({ message: t("validation.required") }),
      }
    ),
    country: z.string().min(1, t("validation.required")),
    enabled: z.boolean(),
  });

export type FeatureFlagRuleFormData = z.infer<
  ReturnType<typeof featureFlagRuleSchema>
>;
